import { render, staticRenderFns } from "./HomeShelfItem.vue?vue&type=template&id=a5c8f46a&scoped=true&"
import script from "./HomeShelfItem.vue?vue&type=script&lang=js&"
export * from "./HomeShelfItem.vue?vue&type=script&lang=js&"
import style0 from "./HomeShelfItem.vue?vue&type=style&index=0&id=a5c8f46a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c8f46a",
  null
  
)

export default component.exports